import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-435f8a1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[40px] px-10" }
const _hoisted_2 = { class: "list" }

import { toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useGlobalStore } from '@/stores/global';
import SlideItem from '@/components/common/SlideItem.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const globalStore = useGlobalStore();
const { excursions } = toRefs(globalStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: _unref(t)('excursion.title')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(excursions)?.data, (excursion) => {
        return (_openBlock(), _createBlock(SlideItem, {
          key: excursion.id,
          id: excursion.id,
          title: excursion.attributes.title,
          text: excursion.attributes.subtitle,
          url: excursion.attributes.img.data?.attributes.url,
          price: excursion.attributes.summForGroup,
          onClick: ($event: any) => (
                    _unref(router).push({
                        name: 'excursion',
                        params: {
                            id: excursion.id,
                        },
                    })
                )
        }, null, 8, ["id", "title", "text", "url", "price", "onClick"]))
      }), 128))
    ])
  ]))
}
}

})